import { Injectable, ErrorHandler, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandledError } from '@fpr/core/models/error.models';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
    private readonly httpService = inject(HttpClient);


    handleError(err: HandledError): void {

        console.error(err);

        const loggableErr = {
            message: err.message || String(err),
            stack: err.stack
        };

        this.httpService.post(`errors`, loggableErr).subscribe();

    }

}
